<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Closing Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="3">
            <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-btn color="accent" @click="closeStock" :loading="closeLoader">Close Stock</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" md="7">
            <v-row>
              <v-col cols="12" xs="12" md="4">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  v-model="queryStore"
                  :items="stores"
                  label="Store"
                  item-text="Name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <v-btn color="primary" @click="queryData" :loading="loader">Query Data</v-btn>
              </v-col>

              <v-col cols="12" style="margin-top: -20px">
                <v-text-field
                  name="closingStockStore"
                  outlined
                  dense
                  label="Search"
                  v-model="search"
                ></v-text-field>
                <!-- start of table -->
                <v-data-table
                :items-per-page="pageItems"
                  :loading="loader"
                  loading-text="Loading Data......"
                  :headers="headers"
                  :items="closingStock"
                  :search="search"
                ></v-data-table>
                <!-- end -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      pageItems: 3000,
      date: new Date().toISOString().substr(0, 10),
      loader: false,
      closeLoader: false,
      headers: [
        { text: "Product Name", value: "product.Name" },
        { text: "Available Qty", value: "ClosingQty" },
      ],
      closingStock: [],
      search: null,
      queryStore: null,
      stores: [],
    };
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    queryData() {
      const url = "/closing/stock/query";
      const self = this;
      const data = {
        date: self.date,
        storeId: self.queryStore
      };
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.closingStock = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    closeStock() {
      const url = "/close/stock";
      const self = this;
      const data = {
        date: self.date,
      };
      this.closeLoader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.closeLoader = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.closeLoader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStores();
  },
};
</script>

<style lang="scss" scoped>
</style>